import type { SxProps, Theme } from '@mui/material/styles'
import { homeContentShellSx } from '@/features/home/styles/homeStyles'

export {
  homeContentInnerSx as notificationsContentInnerSx,
  homePageRootSx as notificationsPageRootSx,
} from '@/features/home/styles/homeStyles'

export const notificationsContentShellSx = {
  ...homeContentShellSx,
  flex: 1,
  pb: 4,
} as const

export const notificationsPageTitleSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: { xs: '24px', md: '32px' },
  fontWeight: 700,
  lineHeight: { xs: '32px', md: '40px' },
  letterSpacing: '0.4063px',
  color: '#0f1729',
  mt: { xs: 3, md: '49px' },
  mb: '8px',
}

export const notificationsPageSubtitleSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '21px',
  color: '#6b7a90',
  mb: { xs: 3, md: '24px' },
}

export const notificationsCardSx: SxProps<Theme> = {
  bgcolor: '#fcfcfc',
  border: '1px solid #e2e8f0',
  borderRadius: '15px',
  overflow: 'hidden',
}

export const notificationsCardHeaderSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexWrap: 'wrap',
  gap: 1,
  px: { xs: 2, md: '33px' },
  pt: '23px',
  pb: '20px',
}

export const notificationsCardTitleSx: SxProps<Theme> = {
  fontFamily: '"Plus Jakarta Sans", "Inter", sans-serif',
  fontSize: '16px',
  fontWeight: 700,
  lineHeight: 'normal',
  letterSpacing: '0.1262px',
  color: '#130856',
  textTransform: 'capitalize',
}

export const notificationsCardActionsSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  flexShrink: 0,
}

export const notificationsMarkAllSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '15px',
  fontWeight: 400,
  lineHeight: '22.5px',
  color: '#008cd0',
  textTransform: 'none',
  p: 0,
  minWidth: 'auto',
  '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
}

export const notificationsClearReadSx: SxProps<Theme> = {
  ...notificationsMarkAllSx,
}

export const notificationsTabsRowSx: SxProps<Theme> = {
  display: 'flex',
  gap: '10px',
  px: { xs: 2, md: '18px' },
  pt: '8px',
  pb: '16px',
  overflowX: { xs: 'auto', md: 'visible' },
}

export const notificationTabSx = (active: boolean): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '36px',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '24px',
  px: '25px',
  borderRadius: '30px',
  border: `1px solid ${active ? '#cce5ff' : '#e2e8f0'}`,
  cursor: 'pointer',
  bgcolor: active ? 'rgba(204, 229, 255, 0.3)' : '#ffffff',
  color: active ? '#006192' : '#0f172a',
  fontFamily: '"Inter", sans-serif',
})

export const notificationsListSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
}

export const notificationFullCardSx = (isUnread: boolean, isClickable: boolean): SxProps<Theme> => ({
  display: 'flex',
  alignItems: { xs: 'flex-start', md: 'center' },
  flexWrap: { xs: 'wrap', md: 'nowrap' },
  gap: '16px',
  minHeight: '75px',
  px: { xs: 2, md: '33px' },
  py: { xs: 1.5, md: 0 },
  m: 0,
  boxSizing: 'border-box',
  bgcolor: isUnread ? '#eff6ff' : '#fcfcfc',
  border: 'none',
  borderTop: '1px solid #e2e8f0',
  borderRadius: 0,
  outline: 'none',
  appearance: 'none',
  cursor: isClickable ? 'pointer' : 'default',
  textAlign: 'left',
  width: '100%',
  font: 'inherit',
  color: 'inherit',
  '&:hover': isClickable ? { bgcolor: isUnread ? '#e8f4fc' : '#f8fafc' } : undefined,
  '&:focus-visible': {
    outline: '2px solid #008cd0',
    outlineOffset: -2,
  },
})

export const notificationIconTileSx: SxProps<Theme> = {
  width: 42,
  height: 42,
  borderRadius: '6px',
  bgcolor: '#dce9ff',
  border: '1px solid #d2ddf4',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  color: '#008cd0',
}

export const notificationIconImgSx: SxProps<Theme> = {
  width: 24,
  height: 24,
  display: 'block',
}

export const notificationsLoadMoreWrapSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'center',
  py: '24px',
}

export const notificationsLoadMoreButtonSx: SxProps<Theme> = {
  fontFamily: '"Inter", sans-serif',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#64748b',
  textTransform: 'none',
  border: '1px solid #94a3b8',
  borderRadius: '9px',
  height: '42px',
  minWidth: '112px',
  px: '20px',
  bgcolor: 'transparent',
  '&:hover': {
    bgcolor: '#f8fafc',
    borderColor: '#94a3b8',
  },
}
